var exports = {
  "j": "isDraggedOver__GB55Yx",
};

module.exports = exports;
